const FORM_URL_MAP: Record<string, string> = {
  '戒色完全指南 - 联系我们表单': 'https://readdy.ai/api/form/d9u3qbtca23r0tr1apu0',
};

export async function getFormUrl(name: string): Promise<string> {
  if (FORM_URL_MAP[name]) return FORM_URL_MAP[name];
  return '';
}